import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "pb-3" }
const _hoisted_3 = { class: "mt-3" }
const _hoisted_4 = {
  key: 0,
  class: "row mt-3"
}
const _hoisted_5 = { class: "col" }
const _hoisted_6 = {
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_7 = { class: "" }
const _hoisted_8 = {
  key: 1,
  class: "row mt-3"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "alert alert-primary",
    role: "alert"
  }, "No results")
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 2,
  class: "row mt-3 py-3 border-bottom border-top bg-light"
}
const _hoisted_12 = { class: "col" }
const _hoisted_13 = {
  key: 0,
  class: "row"
}
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "row pt-3" }
const _hoisted_17 = { class: "col" }
const _hoisted_18 = {
  key: 0,
  class: "d-flex mt-5 justify-content-center align-items-center"
}
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col d-flex justify-content-center mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_VPagination = _resolveComponent("VPagination")!
  const _component_confirm_dialog = _resolveComponent("confirm-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.nameComputed), 1),
        (_ctx.error != '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.error), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _renderSlot(_ctx.$slots, "filters", { loadPage: _ctx.loadPage })
        ]),
        (_ctx.error == '' && !_ctx.loading && _ctx.items.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
          : _createCommentVNode("", true),
        (_ctx.showTitle || _ctx.showEdit)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                (_ctx.showTitle)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("h4", null, _toDisplayString(_ctx.selectedItem.id != null ? "Edit" : "Add New") + " " + _toDisplayString(_ctx.itemNameComputed), 1)
                      ]),
                      (_ctx.selectedItem.id != null)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            style: {"cursor":"pointer"},
                            title: "Stop editing",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.unselectItem()))
                          }, [
                            _createVNode(_component_font_awesome_icon, {
                              class: "mr-3",
                              icon: ['fas', 'times']
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.selectedItem != null && _ctx.showEdit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _renderSlot(_ctx.$slots, "edit", {
                        selectedItem: _ctx.selectedItem,
                        updateItem: _ctx.updateItem,
                        deleteItem: _ctx.deleteItem,
                        addItem: _ctx.addItem,
                        itemName: _ctx.itemNameComputed,
                        getItem: _ctx.getItem
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            (_ctx.loading && _ctx.error.length != 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "text-primary",
                    icon: ['fas', 'spinner'],
                    size: "lg",
                    spin: ""
                  })
                ]))
              : _createCommentVNode("", true),
            (!_ctx.loading && _ctx.items.length > 0)
              ? _renderSlot(_ctx.$slots, "list", {
                  key: 1,
                  loadPage: _ctx.loadPage,
                  items: _ctx.items,
                  setSelected: _ctx.setSelected,
                  setSort: _ctx.setSort,
                  updateItem: _ctx.updateItem,
                  deleteItem: _ctx.deleteItem,
                  sortBy: _ctx.sortBy,
                  sortByDescending: _ctx.sortByDescending,
                  getItem: _ctx.getItem
                })
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_VPagination, {
                  pagination: _ctx.pagination,
                  "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pagination) = $event)),
                  onPageChanged: _cache[2] || (_cache[2] = (page) => _ctx.loadPage(page)),
                  class: "float-right"
                }, null, 8, ["pagination"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_confirm_dialog, { ref: "confirmDialog" }, null, 512)
  ], 64))
}